import React from "react";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { useT } from "@/i18n/LanguageContext";

const PARTNERS = [
  "Maersk",
  "DHL",
  "CMA CGM",
  "MSC",
  "FedEx",
  "Kuehne+Nagel",
  "DB Schenker",
  "DSV",
  "Bolloré Logistics",
  "Hapag-Lloyd",
  "Geodis",
  "Yang Ming",
];

export default function Partners() {
  const { t } = useT();
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative bg-white py-20 lg:py-28 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-6"
        >
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="overline">{t.partners.overline}</span>
              <div className="h-px w-16 bg-slate-300" />
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-[-0.02em] leading-[1.05] text-slate-900 max-w-3xl">
              {t.partners.title}
            </h2>
          </div>
          <p className="text-slate-600 max-w-md">
            {t.partners.body}
          </p>
        </motion.div>
      </div>

      {/* Marquee row 1 */}
      <Marquee
        speed={45}
        gradient
        gradientColor="rgb(255, 255, 255)"
        gradientWidth={120}
        pauseOnHover
        className="py-3"
      >
        {PARTNERS.map((p, i) => (
          <PartnerCard key={`r1-${i}`} name={p} />
        ))}
      </Marquee>

      {/* Marquee row 2 reverse */}
      <Marquee
        speed={35}
        direction="right"
        gradient
        gradientColor="rgb(255, 255, 255)"
        gradientWidth={120}
        pauseOnHover
        className="py-3 mt-2"
      >
        {[...PARTNERS].reverse().map((p, i) => (
          <PartnerCard key={`r2-${i}`} name={p} />
        ))}
      </Marquee>
    </section>
  );
}

function PartnerCard({ name }) {
  return (
    <div
      data-testid={`partner-${name.replace(/\s+/g, "-").toLowerCase()}`}
      className="partner-logo mx-3 px-8 h-20 min-w-[220px] rounded-xl border border-slate-200 bg-[#F8F9FA] flex items-center justify-center"
    >
      <span className="font-display text-xl font-semibold tracking-tight text-slate-700">
        {name}
      </span>
    </div>
  );
}
